<!--
    Review Template
-->
<template>
  <v-hover v-slot="{ hover }">
    <v-card
      v-on:click="displayDrawer"
      v-ripple
      rounded
      class="profile-review legacy-review-tile d-flex flex-column rounded-xl"
      :elevation="hover ? activeHover : initialHover"
      :width="250"
      :max-height="250 / aspectRatio + 125"
      :min-height="tallPoster ? 300 : null"
    >
      <v-img :height="250 / aspectRatio" width="250" :src="image" :class="{ hovered: hover }">
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="info"></v-progress-circular>
          </v-row>
        </template>

        <medium-icon :medium="medium" class="overlay-icon" />

        <rating-circle class="overlay-icon" :size="40" :rating="rating" :opacity="0.65"></rating-circle>
      </v-img>

      <div class="review-content">
        <v-card-title class="review-title">{{ title }}</v-card-title>

        <v-card-text class="review-text">
          <span v-if="!review.spoiler">{{ text }}</span>
          <em v-else class="red--text">Contains spoilers!</em>
        </v-card-text>
      </div>
    </v-card>
  </v-hover>
</template>

<script>
import { mapMutations } from "vuex";
import ratingCircle from "./rating-circles/rating-circle-monochrome.vue";
import getAspectRatio, { hasTallPoster } from "../util/getAspectRatio";

export default {
  name: "review-tile-profile-feed",

  components: {
    ratingCircle,
  },

  data: () => ({
    initialHover: 2,

    activeHover: 5,
  }),

  props: {
    /*
				Full Object
		*/
    data: { type: Object, default: () => ({}) },

    width: {
      type: [Number, String],
      default: 200,
    },
  },

  computed: {
    review() {
      return this.data;
    },
    medium() {
      return this.review.work.medium || "";
    },
    image() {
      return this.review.work.posterSource || "https://telemonial.com/unknown.png";
    },
    username() {
      return this.review.author.username || "";
    },
    title() {
      return this.review.work.title || "Unknown Title";
    },
    text() {
      return this.review.review || "";
    },
    // TODO: Remove default
    rating() {
      return this.review.rating || 0;
    },
    // TODO: Remove default
    id() {
      const idNum = this.review.work.id || 0;
      return idNum.toString();
    },

    getRatingIcon() {
      return `mdi-numeric-${this.rating}`;
    },

    aspectRatio() {
      return getAspectRatio(this.medium);
    },
    tallPoster() {
      return hasTallPoster(this.medium);
    },
  },

  methods: {
    getAspectRatio,
    hasTallPoster,
    ...mapMutations(["showDrawer", "closeDrawer"]),

    displayDrawer() {
      this.showDrawer({
        status: "review",
        data: this.review,
      });
    },

    createReview() {
      this.$router.push("/rate");
    },

    async navigateToWork() {
      let workId = this.review.work.id;
      await this.$router.push({
        name: "work",
        params: {
          medium: this.medium,
          workId: workId,
        },
      });
    },
  },
};
</script>

<style scoped>
/*
  Review Content
*/
.v-card .review-content {
  position: relative;

  min-height: 0;
}

.v-card .review-content .review-title {
  display: block;

  white-space: nowrap;
  text-overflow: ellipsis;

  overflow: hidden;

  padding: 4px 0;
}

.v-card.profile-review .review-content .review-title {
  margin-left: 16px;
  width: calc(100% - 16px);
}

.v-card .review-content .review-text {
  overflow: hidden;
}

.v-card .review-content .review-text:before {
  content: "";

  position: absolute;
  left: 0;
  top: 0;

  width: 100%;
  height: 100%;

  background: linear-gradient(transparent 25%, var(--v-card-base) 100%);
}
</style>
